import React from 'react';
import './NowLiveCover.scss';

const NowLiveCover = props => {
  const { state } = props;
  const coverImageStyle = {
    backgroundImage: `url(${state.coverImage}), radial-gradient(circle at 50% 50%, transparent 70%, rgba(0,0,0,.5) 300%)`
  };
  return (
    <div className="NowLiveCover">
      <div className="ribbon">
        <span className="ribbonTxt">Nu live</span>
      </div>

      <div className="cover" style={coverImageStyle} />
    </div>
  );
};

export default NowLiveCover;
